import { useParams } from 'react-router'
import useQuestionbankQuestions from '../../../hooks/useQestionbankQuestions'
import BackLink from '../../../components/ui/BackLink';
import QuestionManagementForm from '../../../components/QuestionManagementForm';

function QuestionBankManagementPage() {
  let { topic_id } = useParams()
  const { questions: questionbankData, loading, error: pageError } = useQuestionbankQuestions(topic_id)

  if (loading) {
    return <div className="text-center py-4">Loading question bank details...</div>;
  }

  if (pageError) {
    return <p className="text-center text-gray-600">{pageError}🥲.</p>
  }

  return (
    <div className="max-w-4xl p-4">
      <BackLink/>
      <div className=" mb-2">
        <div className="flex gap-3 items-end">
          <h1 className="text-3xl font-bold text-gray-800">{questionbankData.topic_detail.title}</h1>
          <span className="inline-block bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-2xl uppercase tracking-wider">
            Question Bank
          </span>
        </div>
        <span className="text-xs text-gray-500 font-medium bg-gray-100">
          Course: {questionbankData.topic_detail.course_detail?.title}
        </span>
      </div>
      <div className="mb-6 text-gray-600 text-sm">
        Manage all questions for this topic's question bank below.
      </div>
      <QuestionManagementForm
        parentType={'questionbank'}
        parentId={topic_id}
        initialQuestions={questionbankData.questions}
      />
    </div>
  )
}

export default QuestionBankManagementPage